/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Catalog_Blank_ResolutionInputs */

const en_task_catalog_blank_resolution = /** @type {(inputs: Task_Catalog_Blank_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completed`)
};

const pt_br2_task_catalog_blank_resolution = /** @type {(inputs: Task_Catalog_Blank_ResolutionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Concluída`)
};

/**
* | output |
* | --- |
* | "Completed" |
*
* @param {Task_Catalog_Blank_ResolutionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_catalog_blank_resolution = /** @type {((inputs?: Task_Catalog_Blank_ResolutionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Catalog_Blank_ResolutionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_catalog_blank_resolution(inputs)
	return pt_br2_task_catalog_blank_resolution(inputs)
});